export default function (status) {
    if (!status) {
        return ''
    }
    const class_arr = [
        {
            status_arr: ['申请（需交资料）', '申请', '核验不通过', '复核不通过'],
            classname: 'failed'
        },
        {
            status_arr: ['复核通过'],
            classname: 'passed'
        },
        {
            status_arr: ['初核通过'],
            classname: 'pending'
        }
    ]
    let rs = ''
    class_arr.some(({ status_arr, classname }) => {
        if (status_arr.indexOf(status) > -1) {
            rs = classname
            return true
        }
    })
    return rs
}